/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTopicDto } from '../../models/backend-topic-dto';

export interface HandbookTopicsRetrieve$Params {
  id: string;
}

export function handbookTopicsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: HandbookTopicsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTopicDto>> {
  const rb = new RequestBuilder(rootUrl, handbookTopicsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTopicDto>;
    }),
  );
}

handbookTopicsRetrieve.PATH = '/api/handbook/topics/{id}/';
